import styled from 'styled-components';
import { scrollbarStyle } from '@/utils';

export const TextArea = styled.textarea<{ height: string }>`
  width: 100%;
  height: ${({ height }) => height || '64px'};
  overflow-y: auto;
  overflow-x: hidden;
  resize: none;
  font-family: ${({ theme: { font } }) => font.t2.fontFamily};
  font-size: ${({ theme: { font } }) => font.t2.fontSize};
  padding: 10px;
  ${({
  theme: {
    color: { ui4, ui6 },
  },
}) => scrollbarStyle(ui4, ui6)}
  color: ${({ theme }) => theme.color.ui2};
  border: 1px solid ${({ theme }) => theme.color.ui5};
  border-radius: ${({ theme }) => theme.dist.xxs};
  background-color: ${({ theme: { color } }) => color.ui5};
  &:focus {
    color: ${({ theme }) => theme.color.ui2};
    border: 1px solid ${({ theme }) => theme.color.s1};
    outline: none;
    border-radius: ${({ theme }) => theme.dist.xxs};
  }

  border: none;
  outline: none;

  box-shadow: ${({ theme: { shadows } }) => shadows.innerShadow3};
  cursor: text;

  &:hover {
    box-shadow: ${({ theme: { shadows } }) => shadows.innerShadow};
  }

  &:focus {
    outline: none;
    border: none;
  }
`;
